import { BufferAttribute, BufferGeometry, Color, Line, LineBasicMaterial, AdditiveBlending } from 'three';
import { CONFIG } from '../config.js';

export function createTrail(scene, body, config = CONFIG) {
  const n = config.TRAIL_LENGTH;
  const positions = new Float32Array(n * 3);
  const colors = new Float32Array(n * 3);
  const base = body.baseColor.clone();
  // Head (high index / newest) bright; tail (low index) dim — light filament
  for (let i = 0; i < n; i++) {
    const k = i / Math.max(1, n - 1);
    const c = base.clone().multiplyScalar(0.08 + 0.92 * k * k);
    colors[i * 3] = c.r;
    colors[i * 3 + 1] = c.g;
    colors[i * 3 + 2] = c.b;
  }
  const geo = new BufferGeometry();
  geo.setAttribute('position', new BufferAttribute(positions, 3));
  geo.setAttribute('color', new BufferAttribute(colors, 3));
  geo.setDrawRange(0, 0);
  const mat = new LineBasicMaterial({
    vertexColors: true,
    transparent: true,
    opacity: body.isStar ? 0.78 : 0.62,
    blending: AdditiveBlending,
    depthWrite: false,
  });
  const line = new Line(geo, mat);
  line.frustumCulled = false;
  scene.add(line);
  body.trail = line;
  body.trailClock = 0;
  body.trailPoints = [];
  return line;
}

export function sampleTrail(body, dt, config = CONFIG) {
  if (!body.trail) return;
  body.trailClock += dt;
  if (body.trailClock < config.TRAIL_SAMPLE_DT) return;
  body.trailClock = 0;
  body.trailPoints.push(body.position.clone());
  if (body.trailPoints.length > config.TRAIL_LENGTH) body.trailPoints.shift();
  updateTrailGeometry(body, config);
}

export function updateTrailGeometry(body, config = CONFIG) {
  if (!body.trail) return;
  const attr = body.trail.geometry.attributes.position;
  const n = config.TRAIL_LENGTH;
  const offset = n - body.trailPoints.length;
  for (let i = 0; i < n; i++) {
    const p = body.trailPoints[Math.max(0, i - offset)];
    attr.setXYZ(
      i,
      p ? p.x : body.position.x,
      p ? p.y : body.position.y,
      p ? p.z : body.position.z,
    );
  }
  body.trail.geometry.setDrawRange(offset, body.trailPoints.length);
  attr.needsUpdate = true;
}

export function clearTrail(body) {
  if (!body.trail) return;
  body.trailPoints = [];
  body.trailClock = 0;
  body.trail.geometry.setDrawRange(0, 0);
}
